import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import compose from '@shopify/react-compose'
import { withTranslation } from 'react-i18next'
import { withTheme } from 'react-jss'
import config from 'styles/config'

import { withConfiguration, withEndUser, withPreview } from '@portal/kit/pkg/components'

import styles from './main-nav-style'
import { isRanEligible, hasOffers, hasRan } from 'helpers/ran'
import { withRan } from 'components/providers/ran'

class MainNav extends Component {
  state = {
    menuFits: true,
    isFixed: false
  }

  componentDidMount() {
    this.setNavMode()
    this.setIsFixed()
    window.addEventListener('resize', this.setNavMode)
    window.addEventListener('resize', this.setIsFixed)
    window.addEventListener('scroll', this.setIsFixed)
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setNavMode)
    window.removeEventListener('resize', this.setIsFixed)
    window.removeEventListener('scroll', this.setIsFixed)
  }

  setWrapRef = elmt => {
    this.wrapRef = elmt
  }

  setContainerRef = elmt => {
    this.containerRef = elmt
  }

  setNavMode = () => {
    setTimeout(() => {
      if (!this.containerRef) return

      const menuFits = this.containerRef.offsetWidth > this.wrapRef.scrollWidth

      if (this.state.menuFits !== menuFits) {
        this.setState({ menuFits })
      }
    }, 0)
  }

  setIsFixed = () => {
    const isFixed = window.innerWidth < config.dimensions.mobileMaxWidth && window.scrollY > config.dimensions.headerMobileHeight - this.wrapRef.scrollHeight

    if (this.state.isFixed !== isFixed) {
      this.setState({ isFixed })
    }
  }

  render() {
    return (
      <MainNavDom
        {...this.props}
        {...this.state}
        setWrapRef={this.setWrapRef}
        setContainerRef={this.setContainerRef}
      />
    )
  }
}

const itemClasses = (classes, isOn) => {
  return classNames(
    classes.navItem,
    { [classes.navItemOn]: isOn }
  )
}

// got to do this trick outside the class otherwise react-jss throws an error using some createUseStyles hooks in a class component
const MainNavDom = props => {
  const { t } = props
  const currentPath = props.history.location.pathname
  const classes = styles(props.theme)

  const navItem = (path, label) => {
    const isOn = path === '/' ? currentPath === path : currentPath.indexOf(path) > -1

    return (
      <Link to={path} className={itemClasses(classes, isOn)}>
        {label}
      </Link>
    )
  }

  const mainNavClasses = classNames(
    classes.mainNav,
    { [classes.mainNavWithOverflow]: !props.menuFits },
    { [classes.mainNavIsFixed]: props.isFixed }
  )

  const containerClasses = classNames(
    classes.mainNavContainer,
    { [classes.mainNavContainerWithOverflow]: !props.menuFits }
  )

  const canShowHelp = () => {
    const { tag } = props.portalConfiguration
    return !tag || tag.toLowerCase() !== "iloscamonde"
  }
  return (
    <div className={containerClasses}>
      <nav className={mainNavClasses} ref={props.setContainerRef}>
        <div className={classes.mainNavWrap} ref={props.setWrapRef}>
          {navItem('/', t('nav.home'))}
          {(isRanEligible(props) || hasRan(props)) && navItem('/ran', t('nav.ran'))}
          {hasOffers(props) && navItem('/offers', t('nav.offers'))}
          {navItem('/my-account', t('nav.account'))}
          {canShowHelp() && <a href={process.env.REACT_APP_HELP_URL} target="_blank" rel="noopener noreferrer" className={classes.navItem}>{t('nav.help')}</a>}
        </div>
      </nav>
    </div>
  )
}

MainNav.propTypes = {
  history: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  portalConfiguration: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
}

export default compose(
  withTranslation(),
  withRouter,
  withTheme,
  withConfiguration,
  withEndUser,
  withRan,
  withPreview,
)(MainNav)
